<mat-card class="produit-card mat-elevation-z10">
  <div class="contain-img">
    <a [href]="['/produit/' + (produit.id || produit._id)]" [title]="produit.nomProduit"
      [attr.aria-label]="produit.nomProduit">
      <img mat-card-image ngSrc="{{produit.image}}" width="300" height="200" [title]="produit.nomProduit"
        [alt]="produit.nomProduit" loading="lazy" />
    </a>
    <div class="favorite-content">
      <mat-icon class="favorite" (click)="favoris()">favorite_outline</mat-icon>
    </div>
    <div class="content-price">
      <span class="price">{{ produit.prix }}</span>
    </div>
  </div>
  <mat-card-content>
    <div class="card-content">
      <mat-card-title>
        <a [href]="['/produit/' + (produit.id || produit._id)]" [title]="produit.nomProduit"
          [attr.aria-label]="produit.nomProduit">
          {{
          produit.nomProduit.length > 55
          ? (produit.nomProduit | slice : 0 : 55) + "..."
          : produit.nomProduit
          }}
        </a>
      </mat-card-title>
      <mat-card-subtitle>
        <div class="card-subtile">
          <div class="destination">
            <mat-icon class="location" *ngIf="produit.destination">location_pin</mat-icon>
            <span *ngIf="produit.slugParent">
              <a [href]="getLink(produit.slugParent, categorie, tag, search)"> {{ produit.parent }} </a>/
            </span>
            <a [href]="getLink(produit.slug, categorie, tag, search)">
              {{ produit.destination }}</a>
          </div>
          <div class="count-favorite">
            <mat-icon *ngIf="produit.nbFavoris > 0">favorite</mat-icon>
            <mat-icon *ngIf="produit.nbFavoris === 0">favorite_outline</mat-icon>
            {{ produit.nbFavoris }}
          </div>
        </div>
      </mat-card-subtitle>
      <div class="content-card">
        <p class="categorie-tag">
          <a [href]="getLink(destination, produit.categorie ? produit.categorie : produit.categorie, tag, search)">
            {{
            produit.nameCategorie ? produit.nameCategorie : produit.categorie
            }}</a>
          <span *ngFor="let tag of produit.tags.slice(0,5)">
            - <a [href]="getLink(destination, categorie, tag, search)">{{ tag }}</a>
          </span>
        </p>
        <a [href]="['/produit/' + (produit.id || produit._id)]" [title]="produit.nomProduit"
          [attr.aria-label]="produit.nomProduit">
          <p class="description" [innerHtml]="
              produit.description.length > 150
                ? (produit.description | slice : 0 : 150) + ' ...'
                : produit.description
            "></p>
        </a>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <p class="offer">
      {{ produit!.promotion }}
    </p>
  </mat-card-actions>
</mat-card>